<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>

<ng-template #createPortfolioModal>
    <div class="modal-header">
        <h4 class="modal-title">Create New Portfolio</h4>
        <button (click)="modalRef?.hide()" aria-label="Close" class="btn-close" type="button"></button>
    </div>
    <div class="modal-body">
        <app-merchant-profile-form [isAdminCreateMerchant]="true" [showHeading]="false" (onCreatedMerchant)="onPortfolioCreated()"></app-merchant-profile-form>
    </div>
</ng-template>

<div class="merchants-page" (click)="hideContextMenu()">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Portfolios</h1>
            <div class="page-header__actions">
                <button class="btn btn-primary" (click)="createMerchant(createPortfolioModal)">
                    <i class="fa-solid fa-plus"></i> Create Portfolio
                </button>
            </div>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid">
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-building"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Portfolios</span>
                    <span class="stat-card__value">{{ getTotalPortfolios() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-square-parking"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Parkings</span>
                    <span class="stat-card__value">{{ getTotalParkings() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--purple">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-building-columns"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">With Bank Details</span>
                    <span class="stat-card__value">{{ getWithBankDetails() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--teal">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-box-archive"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Deleted</span>
                    <span class="stat-card__value">{{ getDeletedCount() }}</span>
                </div>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="filter-bar">
            <div class="filter-bar__left">
                <div class="status-toggle">
                    <button class="toggle-btn" [class.active]="typeFilter === 'parkupp'" (click)="setTypeFilter('parkupp')">
                        <i class="fa-solid fa-car"></i> ParkUpp
                    </button>
                    <button class="toggle-btn" [class.active]="typeFilter === 'allocate'" (click)="setTypeFilter('allocate')">
                        <i class="fa-solid fa-building-user"></i> Allocate
                    </button>
                    <button class="toggle-btn" [class.active]="typeFilter === 'all'" (click)="setTypeFilter('all')">
                        <i class="fa-solid fa-layer-group"></i> All
                    </button>
                </div>
            </div>
            <div class="filter-bar__right">
                <div class="status-toggle">
                    <button class="toggle-btn" [class.active]="!showDeletedItems" (click)="showDeletedItems && toggleDeletedFilter()">
                        <i class="fa-solid fa-check-circle"></i> Active
                    </button>
                    <button class="toggle-btn" [class.active]="showDeletedItems" (click)="!showDeletedItems && toggleDeletedFilter()">
                        <i class="fa-solid fa-box-archive"></i> Deleted
                    </button>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="merchants && merchants.length === 0">
            <i class="fa-solid fa-building"></i>
            <h3 *ngIf="!showDeletedItems">No active portfolios</h3>
            <h3 *ngIf="showDeletedItems">No deleted portfolios</h3>
            <p *ngIf="!showDeletedItems">Create your first portfolio to get started.</p>
            <p *ngIf="showDeletedItems">Deleted portfolios will appear here.</p>
            <button class="btn btn-primary" *ngIf="!showDeletedItems" (click)="createMerchant(createPortfolioModal)">
                <i class="fa-solid fa-plus"></i> Create Portfolio
            </button>
        </div>

        <!-- Portfolios Table -->
        <div class="table-card" *ngIf="merchants && merchants.length > 0">
            <table class="portfolios-table">
                <thead>
                    <tr>
                        <th *ngFor="let column of columns" (click)="sortByColumn(column.key)">
                            {{ column.label }}
                            <i [class]="getSortIcon(column.key)" class="sort-icon"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let merchant of merchants" 
                        (contextmenu)="onRightClick($event, merchant)" 
                        class="portfolio-row"
                        [class.deleted-row]="merchant.deletedAt">
                        <td>
                            <span class="date-text">{{ merchant.createdAt | daysAgo }}</span>
                        </td>
                        <td>
                            <span *ngIf="merchant.bookuppEnabled" class="type-badge type-badge--allocate">Allocate</span>
                            <span *ngIf="!merchant.bookuppEnabled" class="type-badge type-badge--parking">Parking</span>
                        </td>
                        <td>
                            <span *ngIf="merchant.commissionPercentage === 0" class="fee-badge fee-badge--exception">
                                {{ merchant.commissionPercentage }}%
                            </span>
                            <span *ngIf="merchant.commissionPercentage && merchant.commissionPercentage !== 0" class="fee-badge fee-badge--custom">
                                {{ merchant.commissionPercentage }}%
                            </span>
                            <span *ngIf="!merchant.commissionPercentage && merchant.commissionPercentage !== 0" class="fee-badge fee-badge--default">
                                15%
                            </span>
                        </td>
                        <td>
                            <a [routerLink]="['/merchant/', merchant.$key]" class="portfolio-link">
                                <span class="portfolio-name">{{ merchant.companyName || '' }}</span>
                                <span *ngIf="!merchant.companyName" class="portfolio-id">{{ merchant.$key }}</span>
                            </a>
                        </td>
                        <td>
                            <span *ngIf="merchant.$parkings && merchant.$parkings?.length != 0" class="count-badge">
                                <i class="fa-solid fa-square-parking"></i> {{ merchant.$parkings.length }}
                            </span>
                            <span *ngIf="!merchant.$parkings || merchant.$parkings?.length === 0" class="text-muted">—</span>
                        </td>
                        <td>
                            <span *ngIf="merchant.$bankDetails && merchant.$bankDetails?.length != 0" class="count-badge count-badge--success">
                                <i class="fa-solid fa-building-columns"></i> {{ merchant.$bankDetails.length }}
                            </span>
                            <span *ngIf="!merchant.$bankDetails || merchant.$bankDetails?.length === 0" class="text-muted">—</span>
                        </td>
                        <td>
                            <span class="data-text">{{ merchant.companyRegistration || '—' }}</span>
                        </td>
                        <td>
                            <span class="data-text">{{ merchant.vatNumber || '—' }}</span>
                        </td>
                        <td>
                            <span class="data-text" *ngIf="merchant.phone">{{ merchant.phone.nationalNumber }}</span>
                            <span *ngIf="!merchant.phone" class="text-muted">—</span>
                        </td>
                        <td>
                            <span class="data-text" *ngIf="merchant.averageResponseTime">
                                {{ merchant.averageResponseTime | simpleTime }}
                            </span>
                            <span *ngIf="!merchant.averageResponseTime" class="text-muted">—</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Context Menu -->
        <div *ngIf="contextMenuVisible" 
             class="context-menu" 
             [style.left.px]="contextMenuX" 
             [style.top.px]="contextMenuY" 
             (click)="$event.stopPropagation()">
            <div *ngIf="selectedMerchant && !selectedMerchant.deletedAt" 
                 (click)="deleteFromContextMenu()" 
                 class="context-menu-item context-menu-item--danger">
                <i class="fa-solid fa-trash"></i>
                <span>Delete Portfolio</span>
            </div>
        </div>
    </div>
</div>
